import * as React from "react";
import {headCells} from "./helper";
import {Row, Typography} from "components";
import {TableRow, TableCell, TableHead} from "@mui/material";

interface HeadProps {}

export const Head: React.FC<HeadProps> = () => {
  return (
    <TableHead>
      <TableRow>
        {headCells.map(({id, disablePadding, label}) => (
          <TableCell key={id} padding={disablePadding ? "none" : "normal"}>
            <Row gap={1}>
              <Typography fontFamily="Rubik-Medium">{label}</Typography>
            </Row>
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
};
